import { render } from "./StoricoReclami.vue?vue&type=template&id=bcf33546&scoped=true"
import script from "./StoricoReclami.vue?vue&type=script&lang=js"
export * from "./StoricoReclami.vue?vue&type=script&lang=js"

import "./StoricoReclami.vue?vue&type=style&index=0&id=bcf33546&scoped=true&lang=css"

import exportComponent from "C:\\Users\\ma-dg\\Desktop\\wa\\ask_wizard\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bcf33546"]])

export default __exports__